import React from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../contexts/Context";
import { lightTint, readableText } from "../utils/themeContrast";

export default function OrderLoading({ title, description, fullScreen = false }) {
  const theme = React.useContext(ThemeContext);
  const { lanIndex } = React.useContext(UserContext);
  const language = React.useContext(LanguageContext)[lanIndex];
  return <LoadingArea themeContext={theme} fullScreen={fullScreen} role="status" aria-live="polite">
    <LoadingCard themeContext={theme}>
      <SpinnerFrame themeContext={theme} aria-hidden="true"><Spinner themeContext={theme} /></SpinnerFrame>
      <h2>{title || language.processingOrder}</h2>
      <p>{description || language.processingOrderDescription}</p>
    </LoadingCard>
  </LoadingArea>;
}
const LoadingArea = styled.div`
  min-height: 100%; width: 100%; box-sizing: border-box; display: grid; place-items: center; padding: 32px 24px;
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
  background: ${p => p.themeContext.backgroundColor || "#fff"};
  ${p => p.fullScreen && `min-height: 100vh; min-height: 100dvh;`}
  @media (max-width: 767px) {
    position: fixed; inset: 0; z-index: 1000;
    width: 100vw; height: 100vh; height: 100dvh; min-height: 0;
    overflow-y: auto;
    padding: max(24px, env(safe-area-inset-top)) max(24px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(24px, env(safe-area-inset-left));
  }
`;
const LoadingCard = styled.div`
  width: 100%; max-width: 300px; box-sizing: border-box; padding: 32px 20px; text-align: center;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  border-radius: 22px; background: ${p => p.themeContext.backgroundColor};
  box-shadow: 0 8px 28px rgba(0,0,0,.04);
  h2 { margin: 20px 0 8px; font-size: 18px; font-weight: 600; line-height: 1.4; }
  p { margin: 0; font-size: 13px; line-height: 1.6; opacity: .75; }
`;
const SpinnerFrame = styled.div`
  display: grid; place-items: center; margin: 0 auto; width: 68px; height: 68px; border-radius: 50%;
  background: ${p => lightTint(p.themeContext.primaryColor, .08)};
`;
const Spinner = styled.div`
  width: 30px; height: 30px; border-radius: 50%; border: 3px solid ${p => lightTint(p.themeContext.primaryColor, .22)};
  border-top-color: ${p => readableText(lightTint(p.themeContext.primaryColor, .08), p.themeContext.primaryColor)};
  animation: orderLoadingSpin 900ms linear infinite;
  @keyframes orderLoadingSpin { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;
